import React, { useCallback, useEffect, useState } from 'react';
import { PayPalButton } from 'react-paypal-button-v2';
import { PapalTransaction, PaypalPayment } from '../../Types/Paypal';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Hidden,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import moment from 'moment';

const Row: React.FC = ({ children }) => {
  return (
    <>
      <Hidden xsDown>
        <Grid item sm={3} />
      </Hidden>
      <Grid item sm={6} xs={12}>
        {children}
      </Grid>
      <Hidden xsDown>
        <Grid item sm={3} />
      </Hidden>
    </>
  );
};

const SuccessDialog: React.FC<{ handleClose: () => void; open: boolean }> = ({
  handleClose,
  open,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Success</DialogTitle>
      <DialogContent>
        <DialogContentText>Your Transaction was successful</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

interface Props {
  memberTickets: number;
  publicTickets: number;
}

const Raffle: React.FC<Props> = (props) => {
  const { memberTickets = 0, publicTickets = 0 } = props;
  const { raffleId } = useParams<{ raffleId: string }>();
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [tickets, setTickets] = useState(2);
  const [checked, setChecked] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const handleClose = useCallback(() => {
    setName('');
    setContact('');
    setTickets(2);
    setChecked(false);
    setIsSuccessful(false);
    setIsValid(false);
    setShowButton(false);
  }, []);

  useEffect(() => {
    if (name && contact && checked && !isValid) {
      setIsValid(true);
      setTimeout(() => setShowButton(true), 100);
    } else if ((!name || !contact || !checked) && isValid) {
      setIsValid(false);
      setShowButton(false);
    }
  }, [name, contact, checked, isValid]);

  const expired = moment().isAfter(moment('Wed Dec 23 2020 12:00:00 GMT+1000'));
  const isSoldOut =
    raffleId === 'brisBricks202012PublicRaffle'
      ? publicTickets >= 270
      : raffleId === 'brisBricks202012MemberRaffle'
      ? memberTickets >= 270
      : false;
  const numberOfTickets: number =
    raffleId === 'brisBricks202012PublicRaffle'
      ? 270 - publicTickets
      : raffleId === 'brisBricks202012MemberRaffle'
      ? 270 - memberTickets
      : 0;
  return (
    <div className='App'>
      <Grid container spacing={2}>
        {expired ? (
          <Row>
            <Typography style={{ paddingTop: 20 }}>
              So sorry but the Raffle is now closed
            </Typography>
          </Row>
        ) : isSoldOut ? (
          <Row>
            <Typography style={{ paddingTop: 20 }}>So sorry but the Raffle is sold out</Typography>
          </Row>
        ) : (
          <>
            <Row>
              <TextField
                label='Name'
                value={name}
                fullWidth
                helperText='Preferred Name'
                onChange={({ target }) => setName(target.value)}
              />
            </Row>
            <Row>
              <TextField
                label='Contact Info'
                value={contact}
                fullWidth
                helperText='Either a mobile number or an email address'
                onChange={({ target }) => setContact(target.value)}
              />
            </Row>
            <Row>
              <TextField
                value={tickets}
                select
                label='Tickets'
                fullWidth
                helperText='Number of tickets to purchase'
                onChange={({ target: { value } }) => setTickets(Number(value))}
              >
                {Array.from({ length: numberOfTickets }, (v, i) => i).map((v, i) => (
                  <MenuItem key={i} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </TextField>
            </Row>
            <Row>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event, checked) => setChecked(checked)}
                      color='primary'
                    />
                  }
                  label='I Agree'
                />
                <FormHelperText>
                  By selecting this checkbox you acknowledge that you have read and agree to the
                  terms and conditions stated on this page
                </FormHelperText>
              </FormControl>
            </Row>
            <Row>
              <Grid
                container
                alignItems='center'
                spacing={1}
                style={{
                  // width: checked ? '100%' : '0%',
                  transform: `scale(${showButton ? '1,1' : '0,0'})`,
                  overflow: 'hidden',
                  display: isValid ? undefined : 'none',
                  padding: 0,
                  minHeight: showButton ? 55 : 0,
                  transition: 'all .2s',
                }}
                onClick={(e) => e.preventDefault()}
              >
                <Grid item sm={12} md={6}>
                  {tickets} tickets @ $6 per ticket, total: ${tickets * 6}
                </Grid>
                <Grid item sm={12} md={6}>
                  <PayPalButton
                    amount={tickets * 6}
                    currency='AUD'
                    shippingPreference='NO_SHIPPING' // default is "GET_FROM_FILE"
                    options={{
                      clientId:
                        // 'ASB2e5GCRU8-rmHVnsNbKtaKHkDrfxHTBle4u0xTfa25o2f9ICPdA4ZKTZRXFM5xNZsOt8BLmSU17Chr',  // sandbox
                        'Aaj_c5V2w1Fz5jWXnsZFNYoOsdb2-MWkr0q4FkeMEy6HTfI-slwHzWHlGZzSH9cw4hVhVYA5mzCjXHLr', // brisbricks live
                      disableFunding: 'card',
                      currency: 'AUD',
                      integrationDate: '2020-11-29',
                    }}
                    onSuccess={(details: PaypalPayment, data: PapalTransaction) => {
                      const full = {
                        paypal: { details, data },
                        raffleId,
                        name,
                        contact,
                        tickets,
                        checked,
                        orderId: data.orderID,
                      };
                      // console.log(JSON.stringify(full));
                      setIsSuccessful(true);
                      // OPTIONAL: Call your server to save the transaction
                      return fetch(
                        // 'http://localhost:5001/brisbricks/us-central1/webApi/api/v1/transaction',
                        'https://us-central1-brisbricks.cloudfunctions.net/webApi/api/v1/transaction',
                        {
                          method: 'post',
                          body: JSON.stringify(full),
                        }
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Row>
          </>
        )}
      </Grid>
      <SuccessDialog handleClose={handleClose} open={isSuccessful} />
    </div>
  );
};

export default Raffle;
